<template>
  <modal :show="show">
    <div slot="modalHeader">
      <modal-header :closeModal="close"><i class="fa fa-edit"></i>&nbsp; Bulk Edit</modal-header>
      <br>
    </div>

    <div class="bulk-edit-modal">
      <div class="form-group row">
        <label for="fields" class="col-sm-4 col-form-label">Select the field to edit: </label>
        <div class="col-sm-8">
          <select id="fields"
                  name="fields"
                  class="form-control"
                  placeholder="Select one field"
                  @change="onFieldSelected($event)">
            <option>Select one field</option>
            <option v-for="(value, key) in creativeUnitFields" :key="key" :value="key">{{ value }}</option>
          </select>
          <small>
            Select the field that you want to update for all the selected units.
          </small>
        </div>
      </div>
      <div class="form-group row" v-if="this.currentFieldIndex !== null">
        <label for="field_value" class="col-sm-4 col-form-label">New value for {{getFieldNameByIndex(currentFieldIndex)}}</label>
        <div class="col-sm-8">
          <dropdown id="field_value"
                    :options="fpsOptions"
                    v-model="model.value"
                    v-if="getFieldTypeEnable('fpsOptions')" />
          <dropdown id="videoFormatOptions"
                    :options="videoFormatOptions"
                    v-model="model.value"
                    v-if="getFieldTypeEnable('videoFormatOptions')" />
          <dropdown id="masterOptions"
                    :options="masterOptions"
                    v-model="model.value"
                    v-if="getFieldTypeEnable('masterOptions')" />
          <field v-if="getFieldTypeEnable('string')"
                 :type="'text'"
                 v-model="model.value"
                 :value="model.value"/>
          <field v-if="getFieldTypeEnable('number')"
                 :type="'number'"
                 v-model="model.value"
                 :value="model.value"/>
          <color-picker
              v-if="getFieldTypeEnable('color')"
              :color="model.value"
              :creativeType="this.creativeUnitType"
              v-model="model.value"
              />
          <span
                class="creativeUnitTable__imageField"
                @click="(e) => {this.$emit('onUpdateImage', e)}"
                data-modalType="assetLibrary"
                :data-modalID="'0'"
                :data-modalField="'image'"
                :data-modalFieldType="getFieldNameByIndex(currentFieldIndex)"
                v-if="getFieldTypeEnable('image')"
          >
            <span>
              <span class="item"><i aria-hidden="true" class="fa fa-plus"></i> Change Image</span>
            </span>
            <span>
              <br/>
              {{model.value}}
              <br/>
            </span>
            <span>
              <span class="thumb item"><img v-if="model.value" :src="thumbPath( model.value )" width="50%"/></span>
            </span>
            <br/>
          </span>
          <small>
            Add the value for the selected field
          </small>
        </div>
      </div>
    </div>
    <div slot="modalFooter">
      <modal-footer
          :closeModal="() => {close()}"
          :confirm="this.saveChanges"
          :confirmDisabled="!(!!model.value)"
          cancelText="Cancel"
          confirmText="Update"
          confirmTheme="primary" />
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import {modalMixin} from '@/mixins/modalMixin'
import ModalFooter from '@/components/Modal/modal-footer'
import Dropdown from '@/components/Form/Dropdown/dropdown'
import { fpsOptions, videoFormatOptions } from '@/constants/CreativeUnits'
import Field from '@/components/Form/Field/field'
import Tooltip from '@/components/Tooltip/tooltip'
import ColorPicker from '@/components/ColorPicker/color-picker'
import ModalAssetLibrary from '@/components/Modal/assets/modal-asset-library'

import { url } from '@/config'

export default {
  name: 'modal_bulk_edit_unit',
  mixins: [modalMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    Dropdown,
    Field,
    Tooltip,
    ColorPicker,
    ModalAssetLibrary
  },
  props: {
    show: Boolean,
    tableFields: {},
    tableColumns: {},
    tableFieldTypes: {},
    tableData: {},
    selected: {},
    mastersData: {},
    creativeUnitType: String,
    creative: {},
    triggerBulkEdit: Function
  },
  data: () => ({
    currentFieldIndex: null,
    fpsOptions,
    videoFormatOptions,
    model: {
      value: ''
    }
  }),
  mounted () {},
  created () {},
  computed: {
    creativeUnitFields () {
      const videoFields = this.creativeUnitType === 'html-video' ? [
        'render_video_duration',
        'render_video_fps',
        'render_video_format'
      ] : []
      const fields = ['master', 'locale', 'width', 'height', ...videoFields, ...this.tableFields]
      return fields
    },
    masterOptions () {
      return this.mastersData.map((value) => ({name: value, value}))
    }
  },
  methods: {
    getFieldType: function (fieldIndex) {
      const types = [
        'masterOptions', // master
        'string', // locale
        'number', // width
        'number', // height
        ...this.creativeUnitType === 'html-video' ? [
          'number', // render_video_duration
          'fpsOptions', // render_video_fps
          'videoFormatOptions' // render_video_format
        ] : [],
        ...this.tableFieldTypes
      ]
      return (fieldIndex >= 0 && fieldIndex < types.length) ? types[fieldIndex] : undefined
    },
    onFieldSelected: function ($event) {
      this.model.value = ''
      if ($event.target.value) {
        this.currentFieldIndex = $event.target.value
        return true
      }
      this.currentFieldIndex = null
      return false
    },
    getFieldNameByIndex: function (fieldIndex) {
      return this.currentFieldIndex ? this.creativeUnitFields[fieldIndex] : ''
    },
    getFieldTypeEnable: function (fieldType) {
      const type = this.getFieldType(this.currentFieldIndex)
      console.log(type, fieldType)
      if (type !== fieldType) return false
      const field = this.creativeUnitFields[this.currentFieldIndex]
      let allowed = false

      switch (type) {
        case 'masterOptions':
          allowed = true
          break
        case 'fpsOptions':
          allowed = true
          break
        case 'videoFormatOptions':
          allowed = true
          break
        case 'string':
          allowed = true
          break
        case 'number':
          allowed = true
          break
        case 'color':
          allowed = true
          break
        case 'image':
          allowed = true
          break
        default:
          break
      }
      console.log(type, field)
      return allowed
    },
    thumbPath (filename) {
      var thumbpath = url + 'store/' + this.creative.campaign.client.slug.toLowerCase() + '/' + this.creative.campaign.hash_id + '/' + this.creative.hash_id + '/_assets/' + filename + '?ts=' + Math.round(+new Date() / 1000)
      return thumbpath
    },
    setAssetLibraryImageSelected (image) {
      this.model.value = image
    },
    saveChanges: function () {
      const selectedRows = this.selected().ids
      this.tableData.forEach((item, index) => {
        if (selectedRows.includes(item.id)) {
          const fieldKey = this.getFieldNameByIndex(this.currentFieldIndex)
          if (item.fields.hasOwnProperty(fieldKey)) {
            item.fields[fieldKey] = this.model.value
          } else {
            item[fieldKey] = this.model.value
          }
        }
      })
      this.triggerBulkEdit()
      this.close()
    }
  }
}
</script>

<style lang="scss">
.modal__container {
  width: 750px;
}
.bulk-edit-modal {
  .form-control {
    margin-bottom: 0.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Modal/creatives/modal-bulk-edit-unit.vue